module.exports = __webpack_public_path__ + "img/FavIcone_Dojo.ac8b99da.png";